import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_ADDCOMPANY,
  GET_COMPANYLIST,
  GET_COMPANY_DETAILS,
  GET_GSTCOMPANY,
  GET_PARENT_COMPANYLIST,
  GET_UPDATECOMPANY,
  GET_UPDATEGSTCOMPANY,
  GET_PARENTCOMPANYDETAILS
} from "resources/actionTypes";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addCompanyApi,
  fetchCompanyApi,
  fetchCompanyProfile,
  addGstCompanyApi,
  updateCompanyApi,
  updateGstCompanyApi,
  fetchParentCompanyList,
  fetchParentCompanyDetails,
  deleteCompanyApi
} from "services/CompanyService";
import store from "redux/store";
import {
  fetchCompanyDetails,
  fetchCompanyList,
} from "redux/actions/companyAction";
import { onLoaderTrigger } from "redux/actions/commonAction";

function* companyListSaga(action) {
  const payload = action.payload || {};

  if(payload?.searchKey?.loader) {
    store.dispatch(onLoaderTrigger(true));
  }
  const comanyList = yield call(fetchCompanyApi, payload);

  if (comanyList.success) {
    yield put({
      type: GET_COMPANYLIST.GET_COMPANYLIST_SUCCESS,
      companyList: comanyList?.data,
    });
  } else {
    yield put({
      type: GET_COMPANYLIST.GET_COMPANYLIST_FAILED,
      message: comanyList.message,
    });
  }

  store.dispatch(onLoaderTrigger(false));

}

export function* onCompanyListWatcher() {
  yield takeEvery(GET_COMPANYLIST.GET_COMPANYLIST_REQUESTED, companyListSaga);
}

function* companyProfile(action) {
  const payload = action.payload || {};
  const comanyProfile = yield call(fetchCompanyProfile, payload.id);

  if (comanyProfile.success) {
    yield put({
      type: GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_SUCCESS,
      companyProfile: comanyProfile?.data,
    });
  } else {
    yield put({
      type: GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_FAILED,
      message: comanyProfile.message,
    });
  }
}

export function* onCompanyProfileWatcher() {
  yield takeEvery(
    GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_REQUESTED,
    companyProfile
  );
}

function* parentCompanyList(action) {
  const payload = action.payload || {};

  if(payload?.searchKey?.loader) {
    store.dispatch(onLoaderTrigger(true));
  }
  const parentCompanies = yield call(fetchParentCompanyList,payload);

  if (parentCompanies.success) {
    yield put({
      type: GET_PARENT_COMPANYLIST.GET_PARENT_COMPANYLIST_SUCCESS,
      parentCompanyList: parentCompanies?.data,
    });
  } else {
    yield put({
      type: GET_PARENT_COMPANYLIST.GET_PARENT_COMPANYLIST_FAILED,
      message: parentCompanies.message,
    });
  }
  store.dispatch(onLoaderTrigger(false));
}

export function* parentCompanyListWatcher() {
  yield takeEvery(
    GET_PARENT_COMPANYLIST.GET_PARENT_COMPANYLIST_REQUESTED,
    parentCompanyList
  );
}

function* companyOnboardingSaga(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  
  // Check if this is a delete action
  if (action.isDelete) {
    const deleteCompany = yield call(deleteCompanyApi, payload.companyId);
    if (deleteCompany.success) {
      yield put({
        type: GET_ADDCOMPANY.GET_ADDCOMPANY_SUCCESS,
        addCompany: deleteCompany,
      });
      toast.success(deleteCompany.message);
      store.dispatch(onLoaderTrigger(false));
      // Redirect to companies list page
      if (payload.navigate) {
        payload.navigate('/companies', { replace: true });
      }
    } else {
      yield put({
        type: GET_ADDCOMPANY.GET_ADDCOMPANY_FAILED,
        message: deleteCompany.message,
      });
      toast.error(deleteCompany?.message || "Deleting Company Failed");
      store.dispatch(onLoaderTrigger(false));
    }
  } else {
    // Add company flow
    const addCompany = yield call(addCompanyApi, payload.companyOnboardData);
    if (addCompany.success) {
      yield put({
        type: GET_ADDCOMPANY.GET_ADDCOMPANY_SUCCESS,
        addCompany: addCompany,
      });
      toast.success(addCompany.message);
      payload.setContractDetails(false);
      store.dispatch(onLoaderTrigger(false));
      // Redirect to companies list page
      if (payload.navigate) {
        payload.navigate('/companies', { replace: true });
      }
    } else {
      yield put({
        type: GET_ADDCOMPANY.GET_ADDCOMPANY_FAILED,
        message: addCompany.message,
      });
      toast.error(addCompany?.message || "Adding Company Onboarding Failed");
      store.dispatch(onLoaderTrigger(false));
    }
  }
}

export function* onCompanyOnboardWatcher() {
  yield takeEvery(
    GET_ADDCOMPANY.GET_ADDCOMPANY_REQUESTED,
    companyOnboardingSaga
  );
}

// Update Company Details
function* updateCompanyOnboardingSaga(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const updateCompany = yield call(updateCompanyApi, payload.updateCompanyOnboardData);

  if (updateCompany.success) {
    yield put({
      type: GET_UPDATECOMPANY.GET_UPDATECOMPANY_SUCCESS,
      addCompany: updateCompany,
    });
    toast.success(updateCompany.message);
    store.dispatch(onLoaderTrigger(false));
    if(payload?.payloadObj?.pageType === "companyListPage") {
      store.dispatch(fetchCompanyList(payload?.payloadObj?.companyListPayload));
    }
    else if (payload?.payloadObj?.pageType === "companyOnboardingPage") {
      payload.payloadObj?.setContractDetails(false);
    }
    else {
      payload.payloadObj?.setPrevieModel()
    }
    
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({
      type: GET_UPDATECOMPANY.GET_UPDATECOMPANY_FAILED,
      message: updateCompany.message,
    });
    toast.error(updateCompany?.message || "Updating Company Onboarding Failed");
  }
}

export function* onUpdateCompanyOnboardWatcher() {
  yield takeEvery(
    GET_UPDATECOMPANY.GET_UPDATECOMPANY_REQUESTED,
    updateCompanyOnboardingSaga
  );
}

// GST Form Adding
function* gstCompanySaga(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const gstCompany = yield call(addGstCompanyApi, payload.companyGstData);
  if (gstCompany.success) {
    yield put({
      type: GET_GSTCOMPANY.GET_GSTCOMPANY_SUCCESS,
      gstCompany: gstCompany,
    });
    toast.success(gstCompany.message);
    store.dispatch(onLoaderTrigger(false));
    const companyId = payload?.companyGstData?.companyId
    payload.navigate(`/companies/companyProfile/${companyId}`);
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({
      type: GET_GSTCOMPANY.GET_GSTCOMPANY_FAILED,
      message: gstCompany.message,
    });
    toast.error(gstCompany?.message || "Adding Company GST Failed");
  }
}

export function* onGstCompanyWatcher() {
  yield takeEvery(GET_GSTCOMPANY.GET_GSTCOMPANY_REQUESTED, gstCompanySaga);
}

//Update GST Company
function* updateGstCompanySaga(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const updateGstCompany = yield call(
    updateGstCompanyApi,
    payload.updateCompanyGstData
  );

  if (updateGstCompany.success) {
    yield put({
      type: GET_UPDATEGSTCOMPANY.GET_UPDATEGSTCOMPANY_SUCCESS,
      updateGstCompany: updateGstCompany,
    });
    toast.success(updateGstCompany.message);
    store.dispatch(onLoaderTrigger(false));
    payload.navigate(
      `/companies/companyprofile/${payload?.updateCompanyGstData?.id}`
    );
    const companyListPayload = {
      id: payload?.updateCompanyGstData?.id,
    };
    store.dispatch(fetchCompanyDetails(companyListPayload));
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({
      type: GET_UPDATEGSTCOMPANY.GET_UPDATEGSTCOMPANY_FAILED,
      message: updateGstCompany.message,
    });
    toast.error(updateGstCompany?.message || "Updating Company GST Failed");
  }
}

export function* onUpdateGstCompanyWatcher() {
  yield takeEvery(
    GET_UPDATEGSTCOMPANY.GET_UPDATEGSTCOMPANY_REQUESTED,
    updateGstCompanySaga
  );
}

// Fetch Parent Company Details
function* parentCompanyDetails(action) {
  const payload = action.payload || {};
  const parentComanyDetails = yield call(fetchParentCompanyDetails, payload.id);

  if (parentComanyDetails.success) {
    yield put({
      type:GET_PARENTCOMPANYDETAILS.GET_PARENTCOMPANYDETAILS_SUCCESS,
      parentCompanyDetails: parentComanyDetails?.data,
    });
  } else {
    yield put({
      type: GET_PARENTCOMPANYDETAILS.GET_PARENTCOMPANYDETAILS_FAILED,
      message: parentComanyDetails.message,
    });
  }
}

export function* onParentCompanyDetailsWatcher() {
  yield takeEvery(
    GET_PARENTCOMPANYDETAILS.GET_PARENTCOMPANYDETAILS_REQUESTED,
    parentCompanyDetails
  );
}
